export const GoogleWebClintId =
  '1009521238443-tu5jjqhh0vi7uuov3jd2jaddj921reke.apps.googleusercontent.com';
export const StripePublishableTestKey =
  'pk_test_51IUwruIaf7K76vtbOIQICotuDdYEaSOxfzelEQ8zdUBe7thajoIUGcl7gEHJr7gAlaDn1oLfNpkGwr06VvFbtaMj00pDY4dLz8';
export const StripePublishableLiveKey =
  'pk_live_51IUwruIaf7K76vtbq81IIqm8LSawwkZswyr8p5MyWOGIu3dltDJvXnflsH0RLX84H8Wmo6i7Mvw1iUnYlXHWlm6t00bTPi3szO';
export const GoogleGeoCodingKey = 'AIzaSyDjfQqZzCIx6lsdAePOSuvb5j7Q52L6yl0';
export const webPushVapidKey =
  'BEwXfVG9krGQpNZPdkUqFVe3KWJXwzsZBEccPSg85TlgB_u5iHcg6sU78XaEk7DdVmdMSYJmTbcAUor2f-afUyE';
